import Component from '../core/Component';
import {scrollTo, disableScrolling, scrollToElement } from '../services/Viewport';
import keycode from 'keycode';

export default class Scroll extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            questions: []
        }
    }

    prepare() {

        this.$questions = $('.question');
        this.offsetFromTop = 20;

        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 20
            }, {easing: 'easeInOutSine',duration: 800});
        })

        this.ref.questions.forEach(element => element.addEventListener('click', this.handleClick))

        document.addEventListener('keydown', event => {
            if (keycode(event.keyCode) === 'down') {
                this.goDown();
            } else if (keycode(event.keyCode) === 'up') {
                this.goUp();
            }
        });

        $('.answer').find("input").change(::this.makePost);
    }

    handleClick = event => {
        if (event.target.tagName.toLowerCase() !== 'input') {
            return
        }

        const index = this.ref.questions.indexOf(event.currentTarget)

        const next = index + 1

        if (next >= this.ref.questions.length) {
            return
        }

        scrollToElement(this.ref.questions[next])
    }

    goDown() {
        let offset = this.getViewPortEl()[0].getBoundingClientRect().top;
        let top = $(window).scrollTop();
        let result = offset + top - this.offsetFromTop;

        scrollTo(result);
    }

    goUp() {
        let prevEl = this.getPrevEl()[0];
        let offset = prevEl ? prevEl.getBoundingClientRect().top : 0;
        let top = $(window).scrollTop();
        let result = top + offset - this.offsetFromTop;

        scrollTo(result);
    }

    makePost(e) {
        let url = $(e.target).data('url');
        let value = $(e.target).val();

        $.ajax({
            url: url,
            data: "value=" + value,
            type: 'POST'
        });
    }

    getNextEl() {
        let scroll = $(window).scrollTop();
        let el;

        for (let i = 0; i < this.$questions.length; i++) {
            el = $(this.$questions[i]);
            if (el.offset().top >= scroll && el.is(':visible')) {
                el = el.parents('.flex').next().find('.question'); //fuj fuj
                break;
            }
        }

        return el;
    }


    getViewPortEl() {
        let scroll = $(window).scrollTop() + this.offsetFromTop;
        let el;


        for (let i = 0; i < this.$questions.length; i++) {
            el = $(this.$questions[i]);
            let offset = Math.floor(el.offset().top);

            if (offset > scroll && el.is(':visible')) {
                break;
            }
        }
        return el;
    }

    getPrevEl() {
        let scroll = $(window).scrollTop();
        let el;

        for (let i = 0; i < this.$questions.length; i++) {
            el = $(this.$questions[i]);
            if (el.offset().top >= scroll && el.is(':visible')) {
                el = el.parents('.flex').prev().find('.question'); //fuj fuj
                break;
            }
        }
        return el;
    }
}


// WEBPACK FOOTER //
// ./components/Scroll.js